<template>
    <Tooltip :text="props.tooltip" position="left" >
        <div class="cursor-pointer size-7 text-gray-700 dark:text-gray-200 hover:rounded-full hover:bg-gray-200 dark:hover:bg-slate-700 p-1 transition-all duration-300" >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
            </svg>
        </div>
    </Tooltip>
</template>
<script setup>
import { defineProps } from 'vue';
const props = defineProps({
    tooltip: {
        type: String
    }
});
</script>